import { Spinner } from '@fluentui/react';
import { Patient } from '../../api';
import { HealAPI } from '../../healApi';
import moment from 'moment-timezone';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { InsurancePlanDocument } from '../../redux/patient/types';
import { RootState } from '../../redux/types';

interface InsuranceAdditionalBenefitsProps {
  patient: Patient;
}

export const InsuranceAdditionalBenefits = (props: InsuranceAdditionalBenefitsProps) => {
  const [fetching, setFetching] = useState(false);
  const [insurancePlan, setInsurancePlan] = useState<InsurancePlanDocument>();
  const visitConfig = useSelector((state: RootState) => state.visits.visitConfig);

  useEffect(() => {
    if (!visitConfig.data) {
      return;
    }

    const patient = props.patient;
    const payerCode = visitConfig.data.payers.find((payer) => payer.id === patient.insuranceId)?.eligiblePayerCode;
    if (!payerCode) {
      return;
    }

    const properDateString = moment(patient.dateOfBirth, 'MM/DD/YYYY').format('YYYY-MM-DD');

    setFetching(true);
    HealAPI.findInsurancePlan(patient.memberId, patient.firstName, patient.lastName, properDateString, payerCode).then((response) => {
      if (response.ok && response.data && response.data.length > 0) {
        setInsurancePlan(response.data[0]);
      }
      setFetching(false);
    });
  }, [props.patient, visitConfig.data]);

  if (!props.patient.insuranceId) {
    return <div>No insurance</div>;
  }

  if (fetching) {
    return <Spinner style={{ alignItems: 'flex-start' }} />;
  }

  if (!insurancePlan) {
    return <div>No additional benefits</div>;
  }

  const benefitElements: JSX.Element[] = insurancePlan.additionalBenefits.map((bene, i) => {
    if (bene && bene.type === 'VISIT_CREDIT') {
      return (
        <div key={i}>
          <div>
            <span style={{ fontWeight: 'bold' }}>{bene.description}</span>
          </div>
          <div style={{ marginLeft: 10 }}>
            <div>
              {bene.credits.remaining} / {bene.credits.total} remaining
            </div>
            <div>Restricted to: {bene.level}</div>
            <div>
              <span style={{ fontStyle: 'italic', color: '#aaaaaa' }}>{bene.code}</span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div key={i}>
          <div>
            <span style={{ fontWeight: 'bold' }}>{bene.description}</span>
          </div>
          <div>
            <span style={{ fontStyle: 'italic', color: '#aaaaaa' }}>{bene.code}</span>
          </div>
        </div>
      );
    }
  });

  return <div>{benefitElements}</div>;
};
